var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnswerQuestionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9688,
    cy: 24.5,
    r: 24,
    fill: "#067B65",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_18738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75 40.0313C35.8054 40.0313 37.7767 39.2147 39.2301 37.7613C40.6835 36.3079 41.5 34.3367 41.5 32.2813C41.5 30.2258 40.6835 28.2546 39.2301 26.8012C37.7767 25.3478 35.8054 24.5313 33.75 24.5312C31.6946 24.5313 29.7233 25.3478 28.2699 26.8012C26.8165 28.2546 26 30.2258 26 32.2813C26 34.3367 26.8165 36.3079 28.2699 37.7613C29.7233 39.2147 31.6946 40.0313 33.75 40.0313Z",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3281 30.8281C31.3281 30.3491 31.4702 29.8809 31.7363 29.4826C32.0024 29.0843 32.3806 28.7739 32.8232 28.5906C33.2657 28.4073 33.7527 28.3593 34.2225 28.4528C34.6923 28.5462 35.1238 28.7769 35.4625 29.1156C35.8012 29.4543 36.0319 29.8858 36.1253 30.3556C36.2188 30.8254 36.1708 31.3124 35.9875 31.7549C35.8042 32.1975 35.4938 32.5757 35.0955 32.8418C34.6972 33.108 34.229 33.25 33.75 33.25",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 37.125C33.6215 37.125 33.4983 37.074 33.4075 36.9831C33.3167 36.8923 33.2656 36.7691 33.2656 36.6406C33.2656 36.5122 33.3167 36.389 33.4075 36.2981C33.4983 36.2073 33.6215 36.1562 33.75 36.1562",
    stroke: "#067B65",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 37.125C33.8785 37.125 34.0017 37.074 34.0925 36.9831C34.1833 36.8923 34.2344 36.7691 34.2344 36.6406C34.2344 36.5122 34.1833 36.389 34.0925 36.2981C34.0017 36.2073 33.8785 36.1562 33.75 36.1562",
    stroke: "#067B65",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 18.7188H29.875",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 24.5312H24.0625",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 30.3438H21.1563",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1563 36.1563H14.375C14.1206 36.1563 13.8686 36.1061 13.6336 36.0088C13.3985 35.9114 13.1849 35.7687 13.005 35.5888C12.6416 35.2254 12.4375 34.7326 12.4375 34.2188V12.9063C12.4375 12.3924 12.6416 11.8996 13.005 11.5362C13.3683 11.1729 13.8611 10.9688 14.375 10.9688H28.1041C28.6176 10.9689 29.1101 11.1728 29.4733 11.5358L33.183 15.2455C33.5459 15.6087 33.7499 16.1011 33.75 16.6146V19.6875",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_18738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(10.9688 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerQuestionsIcon);
export default __webpack_public_path__ + "static/media/AnswerQuestionsIcon.b3b639294b3a8fe8ceeb4c202a05a4c8.svg";
export { ForwardRef as ReactComponent };